import React, { useState, useEffect } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
//Component
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import FormInput from "../../stories/hook-controls/input";
import FormCheckBox from "../../stories/hook-controls/checkbox";
import { Modal } from "../../stories/modal";
import { ReactTable } from "../../stories/react-table";
//Function
import { setDataToFormHookV2,isEmptyStr } from "../../utils/common-function";
import { getMasterColumns } from "./columns/module-maintenance";
import * as alertDialog from "../../utils/alert";
import { buildParameter } from "./parameter";
import * as api from "./api";


function ModuleMaintenance() {
  //Context

  //State
  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [DataList, setDataList] = useState([]);
  const [DataDetail, setDataDetail] = useState({});

  //Event
  const onOpenAddModal = () => {
    setOpenModal(true);
    setEditMode(false);
    setDataDetail(null);
  };
  const onOpenEditModal = () => {
    setOpenModal(true);
    setEditMode(true);
  };
  const onCloseModal = () => {
    setOpenModal(false);
  };

  //Function
  const Edit = (Detail) => {
    onOpenEditModal();
    setDataDetail(Detail);
  };

  //--------
  const fetch = async () => {
    let res = await api.GetModuleMasterList();
    setDataList(res);
  };
  useEffect(() => {
    fetch();
  }, []);

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Module Maintenance" onClickAdd={onOpenAddModal} /*add*/>
          <ReactTable
            keyField="ID"
            data={DataList}
            columns={getMasterColumns(Edit)}
          />
        </BoxTemplate1>
        <DataModal
          editmode={editMode ? 1 : 0}
          open={openModal}
          onClose={onCloseModal}
          search={fetch}
          datadetail={DataDetail}
        />
      </BaseContainer>
    </div>
  );
}

function DataModal(props) {

  const { onClose } = props;
  const { open, editmode } = props;
  const { datadetail, search = () => {}, ...otherprops } = props;
  const method = useForm();
  const { setValue, getValues, setError, clearErrors, errors } = method;

  //Effect
  useEffect(() => {
    if (!open) return;
    if (editmode)
    {
      let data = setDataToFormHookV2(datadetail);
      setTimeout(() =>
        data?.forEach(({ name, value }) => setValue(name, value))
      );
    }
    else{
      setTimeout(() => setValue("ACTIVE", true));
    } 
  }, [datadetail, setValue, open, editmode]);

  const SaveDetail = async () => {

    const ID = editmode ? datadetail.ID : null;
    let param = buildParameter.SaveDetail(ID, getValues());
    //console.log(param)
    let res = await api.SaveModule(param);
    if (res) {
      search();
      onClose();
      alertDialog.inform_success();
    }
  }

  return (
    <div>
      <Modal
        {...otherprops}
        onSave={SaveDetail}
        title={editmode ? "Edit Module" : "Add Module"}
      >
        <FormProvider {...method}>
          <Box m={3} maxWidth="500px" flexGrow={1} className="box-input">
            {editmode === 1 && (
              <Typography variant="subtitle2" display="block" gutterBottom>
                Module Name : {datadetail.MODULE_NAME}
              </Typography>
            )}
             {editmode === 0 && (
              <FormInput name="MODULE_NAME" label="Module Name" />
            )}
          </Box>
          <Box m={3} maxWidth="500px" flexGrow={1} className="box-input">
            <FormInput name="MODULE_GROUP" label="Group Name" />
          </Box>
          <Box m={3} maxWidth="500px" flexGrow={1} className="box-input">
            <FormInput name="SEQUENCE" label="Sequence" type="number" />
          </Box>
          <Box m={3} maxWidth="500px" flexGrow={1} className="box-input">
            <FormInput
              multiline
              rows={3}
              name="MODULE_DESC"
              label="Module Description"
            />
          </Box>
        </FormProvider>
      </Modal>
    </div>
  );
}
export default ModuleMaintenance;
